import { asArray, asObject, asOptional, asString, cast } from '@restless/sanitizers'
import { Config, ContractProperties } from './Config'
import mainnetConfig from './config.mainnet'
import playnetConfig from './config.playnet'
import rinkebyConfig from './config.rinkeby'
import { Network } from './Network'

export function getConfigForNetwork(network: Network, isPlaynetActive: boolean): Config {
  if (isPlaynetActive) {
    return cast<Config>(playnetConfig, asConfig)
  }

  switch (network) {
    case Network.Mainnet:
      return cast<Config>(mainnetConfig, asConfig)
    case Network.Rinkeby:
      return cast<Config>(rinkebyConfig, asConfig)
  }
}

const asContractProperties = asObject<ContractProperties>({
  name: asString,
  group: asString,
})

const asConfig = asObject<Config>({
  spritzConfigs: asObject({
    proxy: asContractProperties,
    syntheticToken: asContractProperties,
    collateralAsset: asContractProperties,
    oracle: asContractProperties,
    state: asContractProperties,
  }),
  rewardPools: asArray(
    asObject({
      name: asString,
      note: asOptional(asString),
      pair: asOptional(asString),
      pairLink: asOptional(asString),
      platform: asOptional(asString),
    }),
  ),
  volatileCollaterals: asArray(asString),
  curvePool: asOptional(
    asObject({
      poolAddress: asString,
      poolRegistryAddress: asString,
      depositZap: asString,
      minimalPoolPartPercentage: asString,
    }),
  ),
})
